import { Navigate, Outlet } from "react-router-dom";

import { useGetOrganization } from "@/hooks/api/organization/useGetOrganization";
import { OrganizationType } from "@/types/organization";

type OrganizationTypeRouteProps = {
  allowedType: OrganizationType;
};

export const OrganizationTypeRoute = ({
  allowedType,
}: OrganizationTypeRouteProps) => {
  const { data: organization, isLoading } = useGetOrganization();

  if (isLoading) {
    return null;
  }

  if (!import.meta.env.DEV && organization?.type !== allowedType) {
    return <Navigate replace to="/dashboard" />;
  }

  return <Outlet />;
};
